import React, { Component } from "react";
import * as PropTypes from "prop-types";
import axios from "axios";
import { Alert, Button, DatePicker, Form, Spin, message, Modal } from "antd";

import { API_ERRO_TYPE_CANCEL } from "./../../config/general";

import { companiesService } from "../../redux/services";

import moment from "moment";

import { UIDrawerForm, UISteps } from "./../../components";

import GeneralInfoFields from "./components/GeneralInfoFields";

import Adresses from "./Adresses";
import Contacts from "./Contacts";

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

const STEPS = [
	{ key: "general", label: "Informações gerais" },
	{ key: "adresses", label: "Endereços" },
	{ key: "contacts", label: "Contatos" },
];

class Create extends Component {
	static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
	};


	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			isSending: false,
			nextOrder: 1,
			type: null,
			tipo_pessoa: null,
			cnpj_principal: null,
			settings: null,
			displayParamsREPP: true,
			displayAppCompany: true,
			displayAppEmployee: true,
			activeKey: "general",
			uuid: null,
			item: null,
			addressesCount: 0,
		};

		this._submitIntent = "continue";
	}

	componentDidMount() {
		this.handleCheckCompanyHasAccessREPP();
	}

	fetchCompanies = () => {
		companiesService.getAll({
			orderBy: "nome:asc",
		})
		.then((response) => {
			this.setState({
				settings: {
					app_funcionario: response.data.configuracao.app_funcionario,
					app_empresa: response.data.configuracao.app_empresa,
				},
			});
		})
		.catch((data) => {
			if( data.error_type === API_ERRO_TYPE_CANCEL ) return null;

			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	onOpen = () => {
		this.setState({
			tipo_pessoa: null,
			activeKey: "general",
			uuid: null,
			item: null,
			addressesCount: 0,
		});

		this.fetchCompanies();

		setTimeout(() => {
			this.nome && this.nome.focus()

		}, 100)
	};

	resetFields = () => {
	};

	onClose = () => {
		// Reset fields
		this.resetFields();

		// Callback
		this.props.onClose();
	};

	onFinish = (values) => {
		const file = this.upload.getFiles();

		if (file.hasError) {
			Modal.error({
				title: "Ocorreu um erro!",
				content: file.error,
			});

			return false;
		}

		this.setState({
			isSending: true,
		});

		const { uuid } = this.state;

		const data = { ...values };

		if (uuid) {
			data.uuid = uuid;
		}

		if (data.app_empresa == null) {
			data.app_empresa = 0;
		}

		if (data.app_funcionario == null) {
			data.app_funcionario = 0;
		}

		if (data.cliente_id == null) {
			data.cliente_id = 1;
		}

		if (data.cnpj_principal == null) {
			data.cnpj_principal = false;
		}

		if (data.data_nascimento) {
			data.data_nascimento = data.data_nascimento.format("YYYY-MM-DD");
		} else {
			delete data.data_nascimento;
		}

		if (file.files.length) {
			if (!file.files[0].uuid) {
				data.avatar = file.files[0];
			}
		} else {
			data.avatar = null;
		}

		const request = uuid ? companiesService.edit(data) : companiesService.create(data);

		request
			.then((response) => {
				const newUuid = uuid || response.data.data.uuid;

				this.setState({
					isSending: false,
					uuid: newUuid,
				});

				// Success message
				message.success(uuid ? "Empresa atualizada com sucesso." : "Empresa cadastrada com sucesso.");

				if (this._submitIntent === "exit") {
					// Reset fields
					this.resetFields();

					// Callback
					this.props.onComplete();
				} else {
					// Fetch full company data so Endereços/Contatos/Funcionários/Atestados can load
					companiesService.show({ uuid: newUuid })
						.then((showResponse) => {
							const item = showResponse.data.data;

							this.setState({ item }, () => {
								if (item.avatar) {
									this.upload.setFiles([
										{
											uuid: item.uuid,
											url: item.avatar,
											type: 'image/jpeg',
										}
									]);
								}

								this.tabAdresses && this.tabAdresses.init(item);
								this.tabContacts && this.tabContacts.init(item);

								// Advance to next step
								const currentIndex = STEPS.findIndex((step) => step.key === this.state.activeKey);
								const nextStep = STEPS[currentIndex + 1];

								if (nextStep) {
									this.setState({ activeKey: nextStep.key });
								}
							});
						})
						.catch((data) => {
							Modal.error({
								title: "Ocorreu um erro!",
								content: String(data),
							});
						});
				}
			})
			.catch((data) => {
				this.setState({
					isSending: false,
				});

				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
				});
			});
	};

	handleCheckCompanyHasAccessREPP = () => {
		const companyData = JSON.parse(localStorage.getItem('@mainCompany'));

		this.setState({
			displayParamsREPP: !(!companyData?.app_empresa && !companyData?.app_funcionario),
			displayAppCompany: companyData?.app_empresa,
			displayAppEmployee: companyData?.app_funcionario
		});
	}

	render() {
		const { visible } = this.props;

		const {
			isLoading,
			isSending,
			settings,
			nextOrder,
			tipo_pessoa,
			displayParamsREPP,
			displayAppCompany,
			displayAppEmployee,
			activeKey,
			uuid,
			addressesCount,
		} = this.state;

		const steps = STEPS.map((step, index) => ({
			...step,
			disabled: index > 0 && !uuid,
		}));

		const isLastStep = activeKey === STEPS[STEPS.length - 1].key;
		const canSaveAndExit = activeKey !== "general" || addressesCount > 0;

		return (
			<UIDrawerForm
				visible={visible}
				width={1100}
				onClose={this.onClose}
				isLoading={isLoading}
				isSending={isSending}
				formId={formId}
				showBtnSave={false}
				icon={<i className="fal fa-building" />}
				title="Incluir nova empresa"
				subtitle="Preencha as informações da empresa. Todos os passos são obrigatórios."
				steps={
					<UISteps
						steps={steps}
						current={activeKey}
						onChange={(key) => this.setState({ activeKey: key })}
						hideNav
					/>
				}
				footer={
					<div className="drawer-form-wizard-footer">
						<Button onClick={this.onClose} disabled={isSending}>Cancelar</Button>
						<div className="drawer-form-wizard-footer-actions">
							{canSaveAndExit && (
								<Button
									className="action-btn-secondary"
									form={formId}
									htmlType="submit"
									loading={isSending}
									onClick={() => { this._submitIntent = "exit" }}
								>
									Salvar e sair
								</Button>
							)}
							<Button
								type="primary"
								form={formId}
								htmlType="submit"
								loading={isSending}
								onClick={() => { this._submitIntent = isLastStep ? "exit" : "continue" }}
								icon={<i className={isLastStep ? "fal fa-check" : "fal fa-arrow-right"} />}
							>
								{isLastStep ? "Concluir" : "Salvar e continuar"}
							</Button>
						</div>
					</div>
				}
			>
				<Form
					ref={el => this.form = el}
					id={formId}
					layout="vertical"
					scrollToFirstError
					onFinish={this.onFinish}
					initialValues={{
						order: nextOrder,
						required: true,
						ativo: true,
						dia_fechamento_periodo: 31,
					}}>
					<div style={{ display: activeKey === "general" ? "block" : "none" }}>
						<GeneralInfoFields
							tipo_pessoa={tipo_pessoa}
							onTipoPessoaChange={(value) => this.setState({ tipo_pessoa: value })}
							settings={settings}
							displayParamsREPP={displayParamsREPP}
							displayAppCompany={displayAppCompany}
							displayAppEmployee={displayAppEmployee}
							nomeInputRef={(el) => (this.nome = el)}
							uploadRef={(el) => (this.upload = el)}
							onCnpjPrincipalChange={(evnt) => this.setState({ cnpj_principal: evnt })}
							onDataNascimentoKeyUp={(e) => {
								if (e.keyCode === 13 || e.keyCode === 9) {
									this.tipo_contrato.focus()
								}
							}}
						/>
					</div>
					<div style={{ display: activeKey === "adresses" ? "block" : "none" }}>
						{uuid ? (
							<Adresses
								ref={el => this.tabAdresses = el}
								onAddressesChange={(count) => this.setState({ addressesCount: count })}
							/>
						) : (
							<Alert message="Salve as informações gerais para liberar este conteúdo." type="info" showIcon icon={<i className="fas fa-info-circle" />} />
						)}
					</div>
					<div style={{ display: activeKey === "contacts" ? "block" : "none" }}>
						{uuid ? (
							<Contacts ref={el => this.tabContacts = el} />
						) : (
							<Alert message="Salve as informações gerais para liberar este conteúdo." type="info" showIcon icon={<i className="fas fa-info-circle" />} />
						)}
					</div>
				</Form>
			</UIDrawerForm>
		)
	}
}

export default Create;
